// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slider-arrow-round{align-items:center;background:#e6e6e6;border-radius:100%;bottom:0;height:40px;justify-content:center;margin:auto;top:0;width:40px;z-index:3}.slider-arrow-round:active,.slider-arrow-round:focus{background:#e6e6e6}.slider-arrow-round.swiper-button-disabled{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
